import Vue from "vue";
import Vuex from "vuex";
import residentModule from "./modules/residents";
import authModule from "./modules/auth";
import calenderModule from "./modules/calender";
import digitalSignageModule from "./modules/digitalsignage";
import socialClubModule from "./modules/socialclubs";
import conciergeModule from "./modules/concierge";
import surveyModule from "./modules/surveys";
import maintenanceModule from "./modules/maintenance";
import reportModule from "./modules/reports";
import buddyModule from "./modules/buddy";
import guestbookModule from "./modules/guestbook";
import facilityModule from "./modules/facility";
import userModule from "./modules/user";
import additionalServicesModule from "./modules/additionalServices";
import devicesModule from "./modules/devices";
import messagesModule from "./modules/messages";
import homeMessagesModule from "./modules/homeMessages";
import galleryModule from "./modules/gallery";
import office365Module from "./modules/office365";
import contentLibraryModule from "./modules/contentLibrary";
import businessRulesModule from "./modules/businessRules";
import eventLocationModule from "./modules/eventLocations";
import careLevelsModule from "./modules/careLevels";
import callsModule from "./modules/calls";
import notificationsModule from "./modules/notifications";
import contentCreatorModule from "./modules/contentCreator";
import VuexPersist from "vuex-persist";
import createPersistedState from "vuex-persistedstate";
import localizationModule from "./modules/localization";
import likesModule from "./modules/likes";
import tagsModule from "./modules/tags";
import adHocActivitiesModule from "./modules/adHocActivities";
import commentsModule from "./modules/comments";
import documentsModule from "./modules/documents";
import zendeskModule from './modules/zendesk';
import auditLogsModule from '@/store/modules/auditLogs';
import feedbackModule from './modules/feedbackModule';
import digitalSignageScreenshotsModule from './modules/digitalSignageScreenshots';

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: "staffhub-storage",
  supportCircular: true,
  storage: window.sessionStorage
});

export default new Vuex.Store({
  strict: false,

 plugins: [
  createPersistedState({
    storage: {
      getItem: key => window.localStorage.getItem(key),
      setItem: (key, value) => {
        try {
          window.localStorage.setItem(key, value);
        } catch (e) {
          // localStorage quota exceeded, skip persisting but do not break the app
          console.warn('vuex-persistedstate: unable to persist state', e);
        }
      },
      removeItem: key => window.localStorage.removeItem(key)
    },
    paths: [
      "authModule",
      "socialClubModule",
      "conciergeModule",
      "buddyModule",
      "facilityModule",
      "businessRulesModule",
      "residentModule",
      "localizationModule",
      "likesModule",
      "tagsModule",
      "adHocActivitiesModule",
      "commentsModule",
      "office365Module"
    ]
  })
],

  state: {
    appTitle: "StaffHub"
  },

  mutations: {},

  actions: {},

  modules: {
    residentModule,
    authModule,
    calenderModule,
    digitalSignageModule,
    socialClubModule,
    conciergeModule,
    maintenanceModule,
    surveyModule,
    reportModule,
    buddyModule,
    guestbookModule,
    facilityModule,
    userModule,
    additionalServicesModule,
    devicesModule,
    contentLibraryModule,
    businessRulesModule,
    messagesModule,
    homeMessagesModule,
    notificationsModule,
    galleryModule,
    office365Module,
    eventLocationModule,
    careLevelsModule,
    callsModule,
    contentCreatorModule,
    localizationModule,
    likesModule,
    tagsModule,
    adHocActivitiesModule,
    commentsModule,
    documentsModule,
    zendeskModule,
    auditLogsModule,
    feedbackModule,
    digitalSignageScreenshotsModule
  },

  getters: {}
});
